export class Constants {
    public static APP: string = "ngfizio";
    public static PHOTOS: string = "ngfizio/photos";
    public static PHOTOS_EXTN: string = ".jpeg";
}
